import {forwardRef} from 'react';
import {BleskIcon} from '../types';
import {BaseIcon} from './BaseIcon';

export const Edit: BleskIcon = forwardRef(function Edit(props, ref) {
  return (
    <BaseIcon {...props} ref={ref}>
      <path
        d="m8 21.004 3.151-.39a1 1 0 0 0 .586-.285l8.634-8.63a2.166 2.166 0 0 0 0-3.061v0a2.166 2.166 0 0 0-3.062 0L8.745 17.2a1 1 0 0 0-.283.566z"
        clipRule="evenodd"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M2.996 3.997h13.006M2.996 7.999H12M2.996 12h5.002"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </BaseIcon>
  );
});
